module.exports = __webpack_public_path__ + "static/img/logo.2582858.png";


//////////////////
// WEBPACK FOOTER
// ./static/hk/img/common/logo.png
// module id = ZqiW
// module chunks = 7